import React, { useEffect, useState } from 'react';
import { fetchWrapper } from '../../../_helpers';
import SuccessMessage from '../../successMessage/successMessage';
import ErrorMessage from '../../errorMessage/errorMessage';

const Account = ({ userData }) => {
    // Defaults
    const baseUrl = `${process.env.REACT_APP_API_URL}`;

    // State
    const [updatedUser, setUpdatedUser] = useState(userData);
    const [isLoading, setIsLoading] = useState(false);
    const [updatedSuccess, setUpdatedSuccess] = useState(false);
    const [updatedError, setUpdatedError] = useState(false);

    useEffect(() => {
        setUpdatedError(false);
        setUpdatedSuccess(false);
    }, []);

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setUpdatedError(false);
        setUpdatedSuccess(false);

        switch (name) {
            case 'firstName':
                setUpdatedUser({
                    ...updatedUser,
                    firstName: value,
                });
                break;
            case 'lastName':
                setUpdatedUser({
                    ...updatedUser,
                    lastName: value,
                });
                break;
            default:
                break;
        }
    };

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setUpdatedError(false);
        setUpdatedSuccess(false);

        const urlParams = new URLSearchParams(window.location.search);
        const session_state = urlParams.get('session_state');

        try {
            await fetchWrapper.put(`${baseUrl}/profile/update-user-profile`, {
                ...updatedUser,
                sessionId: session_state,
            });

            setIsLoading(false);
            setUpdatedSuccess(true);
        } catch (error) {
            setIsLoading(false);
            setUpdatedError(true);
        }
    };

    const rerouteToDashboard = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const session_state = urlParams.get('session_state');
        window.location.href = `${process.env.REACT_APP_REDIRECT_URL}?session_state=${session_state}`;
    };

    return (
        <div
            style={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }}
            className='card no-border mb-5 m-md-3 pt-4 pb-5 d-flex align-items-center'
        >
            <div className='card-body'>
                <h2 className='card-header no-border text-center mb-5'>
                    Edit Account
                </h2>
                {updatedSuccess ? (
                    <div className='mb-3'>
                        <SuccessMessage message='YOUR INFORMATION HAS BEEN UPDATED SUCCESSFULLY!' />
                    </div>
                ) : null}
                {updatedError ? (
                    <div className='mb-3'>
                        <ErrorMessage message='YOUR SESSION HAS EXPIRED!' />
                    </div>
                ) : null}
                <form onSubmit={handleOnSubmit}>
                    <div
                        className={`mb-3 gap-4 align-items-center edit-profile-inputs`}
                    >
                        <label className='form-label fw-bold'>Username</label>
                        <input
                            name='username'
                            type='text'
                            className={`form-control`}
                            readOnly={true}
                            disabled={true}
                            value={updatedUser.username}
                        />
                    </div>
                    <div className='mb-3 gap-4 align-items-center edit-profile-inputs'>
                        <label className='form-label fw-bold'>Email</label>
                        <input
                            name='username'
                            type='text'
                            className={`form-control`}
                            readOnly={true}
                            disabled={true}
                            value={updatedUser.email}
                        />
                    </div>
                    <div className='mb-3 gap-4 align-items-center edit-profile-inputs'>
                        <label className='form-label fw-bold'>First Name</label>
                        <input
                            name='firstName'
                            type='text'
                            className={`form-control`}
                            onChange={handleOnChange}
                            defaultValue={updatedUser.firstName}
                        />
                    </div>
                    <div className='mb-3 gap-4 align-items-center edit-profile-inputs'>
                        <label className='form-label fw-bold'>Last Name</label>
                        <input
                            name='lastName'
                            type='text'
                            className={`form-control`}
                            onChange={handleOnChange}
                            defaultValue={updatedUser.lastName}
                        />
                    </div>
                    <div className='mb-3 gap-4 align-items-center edit-profile-inputs'>
                        <label className='form-label fw-bold'>Cell Num.</label>
                        <input
                            name='cellphone'
                            type='text'
                            className={`form-control`}
                            readOnly={true}
                            disabled={true}
                            value={updatedUser.attributes.mobile_number[0]}
                        />
                    </div>
                    <div className='mb-3 gap-4 align-items-center edit-profile-inputs'>
                        <label className='form-label fw-bold'>Gender</label>
                        <input
                            name='gender'
                            type='text'
                            className={`form-control`}
                            readOnly={true}
                            disabled={true}
                            value={updatedUser.attributes.gender[0]}
                        />
                    </div>
                    <div className='w-100 gap-2 d-flex flex-column-reverse flex-md-row gap-4 mt-5 justify-content-center'>
                        <button
                            type='button'
                            onClick={rerouteToDashboard}
                            className='btn btn-splendi-blue fw-bold w-md-50'
                        >
                            Cancel Changes
                        </button>
                        <button
                            type='submit'
                            className='btn btn-splendi-blue fw-bold w-md-50 text-center'
                        >
                            Save Changes
                        </button>
                    </div>
                </form>
                {isLoading ? (
                    <div className='d-flex justify-content-center mt-5'>
                        <span
                            style={{ width: '50px', height: '50px' }}
                            className='spinner-border spinner-border-sm'
                        ></span>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default Account;
